// Professional profile data for Dr. Veerendra C Patil
export const doctorProfile = {
  name: "Dr. Veerendra C Patil",
  nameWithCredentials: "Dr. Veerendra C Patil, MD, FNB, FIAP",
  title: "Pediatric Hematology, Oncology & Bone Marrow Transplant (BMT) Specialist",
  location: "Hyderabad, India",
  image: "https://customer-assets.emergentagent.com/job_web-blueprint-37/artifacts/460dotuv_15957a47-72c7-40fa-866f-18b50a3b397f.JPG",
  
  about: {
    description: "Dr. Veerendra C Patil is a distinguished Pediatric Hematology, Oncology & Bone Marrow Transplant specialist practicing in Hyderabad. With extensive training and expertise in treating complex pediatric blood disorders and cancers, Dr. Patil is committed to delivering world-class, compassionate care to children and their families. His specialized focus includes advanced treatments such as CAR-T cell therapy, making him a pioneer in pediatric oncology care in the region.",
    ashTraining: "Dr Veerendra C Patil has completed a Visitor Training Program in Pediatric Primary Immunodeficiency Diseases and Hematopoietic Stem Cell Transplantation (HSCT) under the American Society of Hematology (ASH) Scholarship in the United States, reflecting his advanced international training and commitment to excellence in pediatric transplant and immunodeficiency care.",
    experience: "14+ years",
    qualifications: ["MD", "FNB", "FIAP"]
  },
  
  clinicalExpertise: [
    {
      title: "Pediatric Oncology",
      description: "Comprehensive diagnosis and treatment of childhood cancers including leukemia, lymphoma, and solid tumors.",
      icon: "activity"
    },
    {
      title: "Pediatric Hematology",
      description: "Expert management of blood disorders including anemia, thalassemia, hemophilia, and other bleeding disorders.",
      icon: "droplet"
    },
    {
      title: "Bone Marrow Transplant (BMT)",
      description: "Specialized in autologous and allogeneic bone marrow transplantation for various hematological conditions.",
      icon: "heart-pulse"
    },
    {
      title: "CAR-T Cell Therapy",
      description: "Advanced immunotherapy treatment for relapsed or refractory pediatric cancers.",
      icon: "shield-plus"
    },
    {
      title: "Pediatric Primary Immunodeficiency Diseases",
      description: "Expert diagnosis and management of inherited immune system disorders in children.",
      icon: "shield"
    },
    {
      title: "Hematopoietic Stem Cell Transplantation (HSCT)",
      description: "Advanced stem cell transplantation including haploidentical HSCT for complex cases.",
      icon: "heart"
    }
  ],
  
  achievements: [
    "Visitor Training Program in Primary Immunodeficiency Diseases and HSCT – American Society of Hematology (ASH) Scholarship, USA",
    "Ex-Executive Board Member – IAP-PHO Chapter, India",
    "14+ years experience in Pediatric Hematology, Oncology & BMT",
    "Expertise in Bone Marrow Transplantation (hematopoietic stem cell transplantation) with special interest in Haploidentical HSCT and CAR-T cell therapy",
    "Evidence-based, ethical pediatric cancer care",
    "Active involvement in pediatric oncology education and training"
  ],
  
  hospitalAffiliation: {
    name: "Basavatarakam Indo-American Cancer Hospital and Research Institute",
    role: "Full-time Consultant - Pediatric Hematology, Oncology & BMT",
    location: "Hyderabad, India",
    description: "Basavatarakam Indo-American Cancer Hospital and Research Institute is one of India's premier comprehensive cancer care centers, offering state-of-the-art facilities and world-class treatment. The hospital is equipped with advanced technology for pediatric oncology care, including dedicated BMT units and CAR-T cell therapy capabilities.",
    facilities: [
      "Advanced Pediatric BMT Unit",
      "Dedicated Pediatric Oncology Ward",
      "CAR-T Cell Therapy Center",
      "24/7 Pediatric Emergency Care",
      "Modern Chemotherapy Day Care",
      "Advanced Diagnostic Facilities"
    ]
  },
  
  conditionsTreated: [
    {
      category: "Pediatric Cancers",
      conditions: [
        "Acute Lymphoblastic Leukemia (ALL)",
        "Acute Myeloid Leukemia (AML)",
        "Hodgkin and Non-Hodgkin Lymphoma",
        "Neuroblastoma",
        "Wilms Tumor",
        "Retinoblastoma",
        "Brain Tumors",
        "Bone and Soft Tissue Sarcomas"
      ]
    },
    {
      category: "Blood Disorders",
      conditions: [
        "Thalassemia Major and Intermedia",
        "Sickle Cell Disease",
        "Aplastic Anemia",
        "Hemophilia A and B",
        "Immune Thrombocytopenia (ITP)",
        "Fanconi Anemia",
        "Bone Marrow Failure Syndromes"
      ]
    },
    {
      category: "BMT Indications",
      conditions: [
        "Leukemia requiring transplant",
        "Severe Aplastic Anemia",
        "Thalassemia Major",
        "Primary Immunodeficiency Disorders",
        "Inherited Metabolic Disorders"
      ]
    }
  ],
  
  contact: {
    email: "dr.veerendrapatil@gmail.com",
    phone: "+91 9000284070",
    hospitalPhone: "+91 40 2335 0000"
  },
  
  seoKeywords: [
    "Pediatric Oncologist Hyderabad",
    "Pediatric Hematologist Hyderabad",
    "BMT Specialist Hyderabad",
    "Bone Marrow Transplant Doctor Hyderabad",
    "CAR-T Cell Therapy Hyderabad",
    "Childhood Cancer Treatment Hyderabad",
    "Pediatric Leukemia Specialist Hyderabad",
    "Thalassemia Treatment Hyderabad",
    "Best Pediatric Oncologist Hyderabad",
    "Basavatarakam Hospital Pediatric Oncology",
    "Dr Veerendra C Patil",
    "Pediatric Blood Cancer Specialist",
    "Children Cancer Hospital Hyderabad",
    "Pediatric BMT Hyderabad"
  ],
  
  clinicalInsights: {
    description: "Educational articles and awareness content on pediatric hematology, oncology, bone marrow transplantation and CAR-T cell therapy will be published here. This content will focus on early diagnosis, treatment principles and patient education for families and referring doctors."
  },
  
  patientEducationVideos: {
    description: "Educational videos on pediatric oncology, hematology, bone marrow transplantation and CAR-T cell therapy will be published here. These videos are intended to support patient and family awareness and do not replace medical consultation."
  }
};